import { Component, ElementRef, inject, input, Input, viewChild, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ngxCsv } from 'ngx-csv';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ModalInventoryReportComponent } from '../modals/modal-inventory-report.component';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: '[app-nav-tanques]',
  imports: [
    ModalInventoryReportComponent,
    RouterLink
  ],
  standalone: true,
  template: `
    <li><button #tanques routerLink="/combustibles/tanques" [class.active]="currentView() === 'tanques'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Tanques</button></li>
    <li><button #refuels routerLink="/combustibles/refuels" [class.active]="currentView() === 'refuels'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Suministro</button></li>
    <li><button #orders routerLink="/combustibles/orders" [class.active]="currentView() === 'orders'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Pedidos</button></li>
    <li><button #services routerLink="/services" [class.active]="currentView() === 'services'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Servicios</button></li>
    <li><button #zonas routerLink="/combustibles/zonas" [class.active]="currentView() === 'zonas'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3">Zonas</button></li>
    <li><button #reporte [class.active]="currentView() === 'reporte'" class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" (click)="modalReport()">Reporte de inventario</button></li>
    <app-modal-inventory-report [profile]="profile" (createReport)="downloadReport($event)"></app-modal-inventory-report>
  `,
  styles: ``
})
export class NavTanquesComponent {
  profile: any = {};
  permissions: any = {};

  currentView = input.required<string>();
  @ViewChild(ModalInventoryReportComponent, { static: true}) modalInventoryReport !: ModalInventoryReportComponent;
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private router: Router
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
  }

  modalReport() {
    // new bs.Modal(<HTMLInputElement>document.getElementById('modalInventoryReport')).show();
    const modalTemplate: any | undefined = this.modalInventoryReport;
    if (modalTemplate) {
      this.modalInventoryReport.openModal(modalTemplate['modalInventoryReport']);
    }
  }

  downloadReport(event: any) {
    console.log("DOWNLOAD REPORT => ", event);  

    console.log('GENERATE REPORT');
    this.store.getTanqueReport({ 
      profile_id: this.profile.id,
      created_at_since: event.created_at_since,
      created_at_to: event.created_at_to
    }).subscribe((data: any) => {
      console.log("REPORT => ", data);
    
      let options = {
        title: 'Reporte de inventario',
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        noDownload: false,
        showTitle: true,
        useBom: true,
        headers: [
          "Nombre",
          "Capacidad",
          "Condominio",
          "Edificio",
          "Lectura",
          "Fecha",
          "Estimación"
        ]
      };

      new ngxCsv(data, 'reporte-inventario', options);
    });
  }
}
